import styled from 'styled-components'

export const Container = styled.footer`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 100%;
`

const Content = styled.div`
  align-items: center;
  border: 1px solid #EEEEEE;
  display: flex;
  justify-content: space-between;
  padding-inline: 62px 38px;
  width: 100%;

  @media (max-width: 764px) {
    padding-inline: 32px;
  }
`

export const Top = styled(Content)`
  gap: 16px;
  padding-block: 16px 24px;
`

export const LinksContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 26px;

  a {
    color: #7649C6;
    font-weight: 700;
    line-height: 18px;
    text-align: end;
    text-decoration: underline;
    white-space: nowrap;
  }

  @media (max-width: 764px) {
    align-items: flex-end;
    flex-direction: column;
    gap: 8px;

    a {
      font-size: 14px;
      line-height: 16px;
    }
  }
`

export const Bottom = styled(Content)`
  gap: 16px;
  padding-block: 8px;

  span {
    color: var(--text-secondary);
    font-size: 12px;
    line-height: 16px;

    @media (max-width: 650px) {
      max-width: 178px;
    }
  }
`
